import "./work-description.css";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import blumeImg from "../../assets/img/petker-blume-1.svg";

const WorkDescription = () => {
	return (
		<section className="work-description">
			<img className="blume-img" src={blumeImg} alt="blume" />
			<div className="container">
				<div className="top-text">
					<span className="sub-title">So arbeiten wir</span>
					<h1 className="title">Pflege mit Herz in Ihrer Nähe</h1>
					<p className="desc">
						Vertrauen und familiäre Atmosphäre sind uns, im Patientenverhältnis
						wie auch untereinander, ein besonderes Anliegen.
					</p>
				</div>
				<div className="desc-cards">
					{/* Card One */}
					<div className="card">
						<i className="icon">
							<SupportAgentRoundedIcon />
						</i>
						<div className="card-text-zone">
							<h3 className="title">24 Stunden Rufbereitschaft</h3>
							<p className="desc">
								Unser Pflegedienst ist für Notfälle und dringende
								Angelegenheiten telefonisch jederzeit erreichbar.
							</p>
						</div>
					</div>
					{/* Card Two */}
					<div className="card">
						<i className="icon">
							<StarsRoundedIcon />
						</i>
						<div className="card-text-zone">
							<h3 className="title">Examiniertes Fachpflegepersonal</h3>
							<p className="desc">
								Wir stellen sicher, dass unser Pflegepersonal ins Team passt,
								immer beste Leistung geben kann und vom Fach ist.
							</p>
						</div>
					</div>
					{/* Card Three */}
					<div className="card">
						<i className="icon">
							<VolunteerActivismRoundedIcon />
						</i>
						<div className="card-text-zone">
							<h3 className="title">Pflege mit Herz und Hand</h3>
							<p className="desc">
								Für ein gutes Miteinander zwischen den pflegebedürftigen Kunden,
								den Angehörigen und den Mitarbeitern.
							</p>
						</div>
					</div>
					{/* Card Four */}
					<div className="card">
						<i className="icon">
							<HomeRoundedIcon />
						</i>
						<div className="card-text-zone">
							<h3 className="title">Familiär, Herzlich & Nah</h3>
							<p className="desc">
								Pflege ist mehr als unser Beruf, sie ist für uns eine
								Herzensangelegenheit.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WorkDescription;
